const VipCrown = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M37.4942 19.6449C37.8902 18.8131 38.7206 18.2042 39.6345 18.0933C40.5055 17.9708 41.4218 18.294 42.0222 18.9403C42.7468 19.6927 42.9872 20.8721 42.6098 21.8486C42.2916 22.7259 41.5089 23.3803 40.6158 23.6043C44.4365 28.3115 48.2573 33.0187 52.0803 37.7235C55.9753 35.7683 59.8622 33.7979 63.7538 31.8381C63.4669 31.3819 63.2393 30.8698 63.2323 30.3227C63.1801 29.3521 63.6794 28.3768 64.4958 27.8553C65.2983 27.3187 66.383 27.2534 67.2447 27.6885C68.1064 28.105 68.7137 28.9974 68.788 29.9552C68.8775 30.8768 68.4675 31.8241 67.7429 32.3945C67.0356 32.9697 66.0415 33.1458 65.1775 32.86C62.3451 40.0555 59.5452 47.265 56.7232 54.4652C45.5758 54.4664 34.4272 54.4652 23.2798 54.4664C20.4601 47.2639 17.666 40.052 14.8324 32.8565C13.9684 33.147 12.972 32.9743 12.2636 32.3957C11.467 31.7809 11.064 30.7135 11.2417 29.7219C11.4333 28.5028 12.5168 27.4984 13.7443 27.412C14.8406 27.3 15.9589 27.9172 16.4571 28.9029C16.9518 29.8199 16.8473 30.99 16.2492 31.8357C20.1385 33.8621 24.037 35.8698 27.9239 37.8997C31.7516 33.1388 35.5653 28.3663 39.3988 23.6101C38.6985 23.4246 38.0528 23.007 37.6626 22.3864C37.1319 21.5861 37.0727 20.5058 37.4942 19.6449Z'
        fill='#EBA33B'
      />
      <path
        d='M23.2797 56.3323C34.4282 56.3288 45.5768 56.3335 56.7254 56.33C56.7219 58.1965 56.7277 60.063 56.7231 61.9296C45.5745 61.9331 34.4259 61.9284 23.2773 61.9319C23.2808 60.0654 23.275 58.1988 23.2797 56.3323Z'
        fill='#EBA33B'
      />
    </svg>
  );
};

export default VipCrown;
